import React, { useState } from 'react';

import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const SearchBar = ({ onSearch, onFilterToggle, activeFilters }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e) => {
    e?.preventDefault();
    onSearch(searchQuery);
  };

  const handleInputChange = (e) => {
    setSearchQuery(e?.target?.value);
    if (e?.target?.value === '') {
      onSearch('');
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <form onSubmit={handleSearch} className="flex items-center space-x-4">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search documents, forms, policies..."
            value={searchQuery}
            onChange={handleInputChange}
            className="w-full"
          />
        </div>
        <Button
          type="submit"
          variant="default"
          iconName="Search"
          iconPosition="left"
        >
          Search
        </Button>
        <Button
          type="button"
          variant="outline"
          iconName="SlidersHorizontal"
          onClick={onFilterToggle}
          className="relative"
        >
          
          Filters
          {activeFilters > 0 && (
            <span className="absolute -top-2 -right-2 w-5 h-5 bg-accent text-accent-foreground text-xs rounded-full flex items-center justify-center">
              {activeFilters}
            </span>
          )}
        </Button>
      </form>
    </div>
  );
};

export default SearchBar;